import React, { useEffect, useRef, useMemo } from 'react';
import { CloseCircleFilled, PlusOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import { useList } from '../../hooks';
import { extractEventValue } from '../../utils/objects';
import { ButtonType, TAButton, TAInput } from '../widgets';

export const DynamicFields = React.memo<any>(
	({ value, min = 0, placeholder, onChange, addBtnText, renderInput, onAdd, preAdded }) => {
		let lastId = useRef(-1);
		let memoizedData = useMemo(
			() => (value ? value.map(d => (d._id ? d : { ...d, _id: ++lastId.current })) : []),
			[]
		);
		let [fields, add, remove, change] = useList(value ? memoizedData : undefined);

		useEffect(() => {
			onChange && onChange(fields);
		}, [fields]);

		const changeField = (field, index) => e => {
			field = { ...field, value: extractEventValue(e) };
			change(index, field);
		};

		const formItems = fields.map((field, index) => {
			return (
				<Row gutter={8} key={`f-${field._id}`}>
					<Col xs={22}>
						{renderInput ? (
							renderInput({
								placeholder: placeholder,
								style: { marginRight: 8 },
								onChange: changeField(field, index),
								value: field.value,
								index: index + preAdded
							})
						) : (
							<TAInput
								placeholder={placeholder}
								style={{ marginRight: 8 }}
								onChange={changeField(field, index)}
								value={field.value}
							/>
						)}
					</Col>
					<Col xs={2}>
						<CloseCircleFilled
							style={{ color: '#FF141E', fontSize: '19px' }}
							onClick={() => {
								remove(index);
							}}
						/>
					</Col>
				</Row>
			);
		});
		return (
			<>
				{formItems}
				<TAButton
					btntype={ButtonType.SECONDARY}
					onClick={e => {
						e.preventDefault();
						onAdd && onAdd();
						add({ _id: ++lastId.current, value: '' });
					}}
					style={{ width: '50%' }}
					className="mt-4 d-flex justify-content-center align-items-center"
				>
					<PlusOutlined /> <span>{addBtnText || 'Add field'}</span>
				</TAButton>
			</>
		);
	}
);
